import { all, fork } from "redux-saga/effects";
import authSaga from "./AuthSaga";

// CUSTOMER
import addressSaga from "./AddressSaga";
import virtualLockerSaga from "./VirtualLockerSaga";
import orderSaga from "./OrderSaga";
import invitationsSaga from "./InvitationsSaga";

// ADMIN
import customerSaga from "./admin/customer-saga";
import shopperSaga from "./admin/shopper-saga";
import productSaga from "./admin/product-saga";
import lockerSaga from "./admin/locker-saga";
import orderDataSaga from "./admin/order-saga";
import settingDataSaga from "./admin/setting-saga";
import roleSaga from "./admin/role-saga";
import groupCartSaga from "./group-cart-saga";

// PERSONAL SHOPPER
import personalShopperSaga from "./PersonalShopper";


export default function* rootSaga() {
  yield all([
    fork(authSaga),
    // CUSTOMER
    fork(addressSaga),
    fork(virtualLockerSaga),
    fork(orderSaga),
    fork(invitationsSaga),
    // ADMIN
    fork(productSaga),
    fork(customerSaga),
    fork(shopperSaga),
    fork(lockerSaga),
    fork(orderDataSaga),
    fork(settingDataSaga),
    fork(roleSaga),
    // PERSONAL SHOPPER
    fork(personalShopperSaga),
    fork(groupCartSaga)
  ]);
}
